import moment from 'moment';

export default class QmsEscalationMatrix {
  constructor({
    _id,
    key,
    isActive,
    matrix = [],
    createdBy,
    createdByName,
    createdAt,
    updatedAt
  }) {
    this.id = _id || '';
    this.key = key || '';
    this.isActive = isActive || false;

    this.matrix = Array.isArray(matrix)
      ? matrix.map((item, index) => new EscalationMatrixRow({ ...item, rowNum: index + 1 }))
      : [];

    this.createdBy = createdBy || '';
    this.createdByName = createdByName || '';

    this.createdAt = createdAt
      ? moment(createdAt).format('DD-MM-YYYY HH:mm')
      : '';

    this.updatedAt = updatedAt
      ? moment(updatedAt).format('DD-MM-YYYY HH:mm')
      : '';
  }
}

/* ---------- Matrix Row ---------- */
class EscalationMatrixRow {
  constructor({
    _id,
    rowNum = 0,
    department,
    tat,
    L1,
    L2,
    L3
  }) {
    this.id = _id || '';
    this.rowNum = rowNum;

    this.department = department || '';
    this.tat = tat || 0;

    this.L1 = L1 ? new EscalationLevel(L1) : null;
    this.L2 = L2 ? new EscalationLevel(L2) : null;
    this.L3 = L3 ? new EscalationLevel(L3) : null;
  }
}

/* ---------- Level ---------- */
class EscalationLevel {
  constructor({ role, users, name, email }) {
    this.role = role || '';
    this.users = Array.isArray(users)
      ? users.map(u => new EscalationUser(u))
      : name || email
        ? [new EscalationUser({ name, email })]
        : [];
  }
}

/* ---------- User ---------- */
class EscalationUser {
  constructor({ _id, id, name, mobile, email, stores, storeIds }) {
    this.id = _id || id || '';
    this.name = name || '';
    this.mobile = mobile || '';
    this.email = email || '';
    const rawStores = stores != null ? stores : storeIds;
    if (Array.isArray(rawStores)) {
      this.stores = rawStores;
    } else if (rawStores != null && String(rawStores).trim()) {
      this.stores = String(rawStores)
        .split(';')
        .map(s => s.trim())
        .filter(Boolean);
    } else {
      this.stores = [];
    }
  }
}
